"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableExportCsvButton = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const table_export_csv_button_styles_1 = require("./table-export-csv-button.styles");
const generic_1 = require("../../generic");
const localization_1 = require("../../../localization");
const TableExportCsvButton = ({ onClick, loading = false, disabled = false, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    return (react_1.default.createElement(ui_components_1.ToolTip, { arrow: true, placement: "top", title: t({ key: 'EXPORT_CSV' }) }, react_1.default.createElement(material_1.IconButton, { size: "small", onClick: onClick, disabled: loading || disabled }, loading
        ? react_1.default.createElement(generic_1.LoadingIndicator, null)
        : react_1.default.createElement(table_export_csv_button_styles_1.StyledDownloadIcon, { width: 20, height: 20 }))));
};
exports.TableExportCsvButton = TableExportCsvButton;
